export const Header = ({ title, icon, description, className }) => {
  return (
    <header>
      <div className={className}>
        <h2>{title}</h2>
        {icon && <span className='material-symbols-rounded'>{icon}</span>}
      </div>
      <p>{description}</p>
    </header>
  )
}
